export default {
  kvText: '雙11來臨，購物狂歡開啟！',
  countdown: {
    start: '距離活動開始還有 {time}',
    end: '距離活動結束還有 {time}',
  },
  verify: {
    title: '角色驗證',
    placeholder: '請輸入您的角色ID',
    accountId: '角色ID',
    accountName: '角色暱稱',
    login: '登入',
    confirm: '請確認您的帳戶信息',
    switchAccount: '重新輸入',
  },
  plaza: '購物廣場',
  desc: '前往線上儲值頁面 [{clickHere}]，每充值100彩鑽，即可獲得一張購物券，您可以使用購物券在購物廣場中購買豐厚獎勵！',
  clickHere: '點此前往',
  eventTime: '活動時間：2026年11月6日 00:00~2026年11月15日23:59（GMT+7）\n獎勵領取時間將於2026年11月22日23:59（GMT+7）截止',
  remaining: '剩餘購物券：{n}',
  remainingLabel: '剩餘購物券：',
  goods: {
    hotDeals: '超值商品',
    dailyDeals: '每日超值',
    viewDaily: '每日超值商品列表',
    price: '{n} 購物券',
    purchase: '購買',
    remainTimes: '剩餘購買次數：{n}',
    notEnoughVoucher: '購物券不足',
    soldOut: '已售罄',
    max: 'MAX',
    confirm: '確認要使用{n}個購物券購買{name}嗎？',
    success: '購買成功，請登入遊戲信箱查收。',
    history: '購買記錄',
    spent: '消耗購物券',
    details: '購買內容',
    time: '購買時間',
    expired: '您購買的道具已過期，請刷新頁面重新選擇。',
    notEnoughDesc: '您的購物券不足，您可以儲值彩鑽獲得更多購物券。',
  },
  milestone: {
    allAchieved: '您可領取全部獎勵',
    subtitle: '累計消耗購物券達標，可獲得豪華寶箱！',
    topUp: '前往儲值',
    history: '領獎記錄',
    claimAll: '一鍵領取',
    nextTip: '再消耗{n}張購物券即可領取下一個獎勵',
    obtained: '已獲得',
    claimable: '可領取',
    notAchieved: '未達成',
    spend: '消耗{n}張購物券',
    header: '里程碑節點',
    rewardDetails: '獎勵詳情',
    claimTime: '領取時間',
    claimSuccess: '領取成功！',
    claimAllSuccessDesc: '一鍵領取成功！\n可前往【{history}】查看獎勵詳情',
    claimSuccessDesc: '道具領取成功，您可以登入遊戲透過信箱查收獎勵！',
  },
  common: {
    empty: '暫無記錄',
    confirm: '確認',
    cancel: '取消',
  },
  rule: {
    title: '活動規則',
    content: [
      '1. 活動期間，透過官方儲值中心儲值彩鑽，即可獲得購物券。每儲值100彩鑽獲得1張購物券。',
      '2. 消耗購物券即可在購物廣場兌換各種道具，包括活動限定頭像框「購物達人」，每天還會刷新驚喜獎勵，僅需1張購物券即可獲得超值獎勵。',
      '3. 消耗購物券可累積購物進度。達到指定進度後，即可領取對應的里程碑寶箱獎勵。',
      '4. 活動結束後，未使用的購物券將作廢，請玩家門及時使用。未領取的里程碑獎勵會自動進行郵件補發。',
      '5. 請透過官方指定的三方支付管道參與活動。因退款、異常訂單或違規行為產生的活動資格及獎勵，將依活動規則處理。',
      '6. 如有任何疑問，請透過本頁面的客服按鈕或遊戲內客服管道聯繫我們。',
    ].join('\n\n'),
  },
  status: {
    notStart: '活動尚未開始',
    ended: '活動已結束',
  },
}
